import * as instructionRoutes from 'registry/InstructionPageRoutes';

export const PRE_LOGIN_INSTRUCTION_ROUTES = {
  NAME_APPLICATION: instructionRoutes.INSTRUCTION_PAGE_MODULES.NAME_APPLICATION,
  ENTITY_REGISTRATION:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.ENTITY_REGISTRATION,
  CESSATION_DISSOLUTION:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.CESSATION_DISSOLUTION,
  STRIKE_OFF: instructionRoutes.INSTRUCTION_PAGE_MODULES.STRIKE_OFF,
  POST_STRIKE_OFF: instructionRoutes.INSTRUCTION_PAGE_MODULES.POST_STRIKE_OFF,
  UPDATE_PERSONNEL_EDIT_PERSONNEL: 'edit-position-holder-instruction',
  UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL:
    'appoint-withdraw-position-holder-instruction',
  REDUCTION_SHARE_CAPITAL:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.REDUCTION_SHARE_CAPITAL,
  REGISTRATION_OF_CHARGES:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.REGISTRATION_OF_CHARGES,
  COMMON_SHARES: 'shares',
  ANNUAL_RETURNS_DECLARATIONS:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.ANNUAL_RETURNS_DECLARATIONS,
  GENERAL_LODGEMENT: 'general-lodgement',
  ENTITY_RENEWAL: instructionRoutes.INSTRUCTION_PAGE_MODULES.ENTITY_RENEWAL,
  OBJ_STRIKING_OFF: instructionRoutes.INSTRUCTION_PAGE_MODULES.OBJ_STRIKING_OFF,
  REGISTER_QUALIFIED_INDIVIDUAL:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.REGISTER_QUALIFIED_INDIVIDUAL,
  RENEW_QUALIFIED_INDIVIDUAL:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.RENEW_QUALIFIED_INDIVIDUAL,
  MAINTENANCE_OF_RORC:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.MAINTENANCE_OF_RORC,
  UPDATE_SHAREHOLDER:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.UPDATE_SHAREHOLDER,
  UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS:
    instructionRoutes.INSTRUCTION_PAGE_MODULES
      .UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS,
  INITIATION_OF_WINDING_UP:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.INITIATION_OF_WINDING_UP,
  EXTENSION_OF_TIME:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.EXTENSION_OF_TIME,
  VARIATION_SATISFACTION:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.VARIATION_SATISFACTION,
  REGISTER_CORPORATE_SERVICE_PROVIDER:
    instructionRoutes.INSTRUCTION_PAGE_MODULES
      .REGISTER_CORPORATE_SERVICE_PROVIDER,
  RENEW_CSP: instructionRoutes.INSTRUCTION_PAGE_MODULES.RENEW_CSP,
  POST_INITIATION_OF_WINDING_UP:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.POST_INITIATION_OF_WINDING_UP,
  UPDATE_ENTITY_INFO: 'update-entity-info',
  FINANCIAL_YEAR_END:
    instructionRoutes.INSTRUCTION_PAGE_MODULES.FINANCIAL_YEAR_END,
  NOTICE_OF_ERROR: instructionRoutes.INSTRUCTION_PAGE_MODULES.NOTICE_OF_ERROR,
  MAINTENANCE_OF_CSP_CLIENT_LIST: 'maintenance-of-csp-client-list',
} as const;

export const POST_LOGIN_INSTRUCTION_REROUTES = {
  [PRE_LOGIN_INSTRUCTION_ROUTES.NAME_APPLICATION]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.NAME_APPLICATION,
  [PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_REGISTRATION]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.ENTITY_REGISTRATION,
  [PRE_LOGIN_INSTRUCTION_ROUTES.CESSATION_DISSOLUTION]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.CESSATION_DISSOLUTION,
  [PRE_LOGIN_INSTRUCTION_ROUTES.STRIKE_OFF]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.STRIKE_OFF,
  [PRE_LOGIN_INSTRUCTION_ROUTES.POST_STRIKE_OFF]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.POST_STRIKE_OFF,
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_EDIT_PERSONNEL]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.UPDATE_PERSONNEL_EDIT_PERSONNEL,
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES
      .UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL,
  [PRE_LOGIN_INSTRUCTION_ROUTES.REDUCTION_SHARE_CAPITAL]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.REDUCTION_SHARE_CAPITAL,
  [PRE_LOGIN_INSTRUCTION_ROUTES.REGISTRATION_OF_CHARGES]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.REGISTRATION_OF_CHARGES,
  [PRE_LOGIN_INSTRUCTION_ROUTES.COMMON_SHARES]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.COMMON_SHARES,
  [PRE_LOGIN_INSTRUCTION_ROUTES.ANNUAL_RETURNS_DECLARATIONS]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.ANNUAL_RETURNS_DECLARATIONS,
  [PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.GENERAL_LODGEMENT,
  [PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_RENEWAL]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.ENTITY_RENEWAL,
  [PRE_LOGIN_INSTRUCTION_ROUTES.OBJ_STRIKING_OFF]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.OBJ_STRIKING_OFF,
  [PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_QUALIFIED_INDIVIDUAL]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.REGISTER_QUALIFIED_INDIVIDUAL,
  [PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_QUALIFIED_INDIVIDUAL]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.RENEW_QUALIFIED_INDIVIDUAL,
  [PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_RORC]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.MAINTENANCE_OF_RORC,
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_SHAREHOLDER]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.UPDATE_SHAREHOLDER,
  [PRE_LOGIN_INSTRUCTION_ROUTES.INITIATION_OF_WINDING_UP]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.INITIATION_OF_WINDING_UP,
  [PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.EXTENSION_OF_TIME,
  [PRE_LOGIN_INSTRUCTION_ROUTES.VARIATION_SATISFACTION]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.VARIATION_SATISFACTION,
  [PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_CORPORATE_SERVICE_PROVIDER]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES
      .REGISTER_CORPORATE_SERVICE_PROVIDER,
  [PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_CSP]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.RENEW_CSP,
  [PRE_LOGIN_INSTRUCTION_ROUTES.POST_INITIATION_OF_WINDING_UP]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.POST_INITIATION_OF_WINDING_UP,
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_ENTITY_INFO]: '/registry/manage/entity',
  [PRE_LOGIN_INSTRUCTION_ROUTES.FINANCIAL_YEAR_END]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.FINANCIAL_YEAR_END,
  [PRE_LOGIN_INSTRUCTION_ROUTES.NOTICE_OF_ERROR]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES.NOTICE_OF_ERROR,
  [PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_CSP_CLIENT_LIST]:
    '/registry/maintenance-of-csp-client-list/my-client',
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS]:
    instructionRoutes.INSTRUCTION_PAGE_ROUTES
      .UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS,
};

export const MAGNOLIA_PATHS = {
  NAME_APPLICATION: '/register/entity/new-business-name/instruction',
  ENTITY_REGISTRATION: '/register/entity/new-business-entity/instruction',
  CESSATION_DISSOLUTION: '/deregister/cessation/instruction',
  STRIKEOFF_BUSINESS_ENTITY: '/deregister/strike-off/entity/instruction',
  POST_INITIATION_STRIKEOFF: '/deregister/strike-off/withdrawal/instruction',
  UPDATE_PERSONNEL_EDIT_PERSONNEL:
    '/manage/personnel-info-registry-entity/update-personnel-info/instruction',
  UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL:
    '/manage/personnel-info-registry-entity/appointment-withdrawal-position-holders/instruction',
  REDUCTION_SHARE_CAPITAL: '/manage/reduction-of-share-capital/instruction',
  REGISTRATION_OF_CHARGES: '/manage/register-new-charge/instruction',
  COMMON_SHARES: '/manage/update-of-shares-information/instruction',
  ANNUAL_RETURNS_DECLARATIONS: '/instructions/entity-filing/instruction',
  GENERAL_LODGEMENT: '/instructions/general-lodgement/instruction',
  ENTITY_RENEWAL: '/instructions/entity-renewal/instruction',
  OBJ_STRIKING_OFF: '/deregister/strike-off/objections/instruction',
  REGISTER_QUALIFIED_INDIVIDUAL:
    '/register/professional/qualified-individuals/instruction',
  RENEW_QUALIFIED_INDIVIDUAL:
    '/register/renewal/registered-qualified-individual/instruction',
  MAINTENANCE_OF_RORC:
    '/manage/update-register-of-registrable-controllers/instruction',
  UPDATE_SHAREHOLDER: '/manage/update-of-shareholder-information/instruction',
  INITIATION_OF_WINDING_UP:
    '/annual-filing/file-winding-up-of-business-entity/instruction',
  EXTENSION_OF_TIME: '/annual-filing/extension-of-time/instruction',
  VARIATION_SATISFACTION:
    '/manage/variation-satisfaction-of-charges/instruction',
  REGISTER_CORPORATE_SERVICE_PROVIDER:
    '/register/corporate-service-provider/instruction',
  RENEW_CSP: '/register/renewal/corporate-service-provider/instruction',
  POST_INITIATION_OF_WINDING_UP:
    '/deregister/post-initiation-of-winding-up/instruction',
  UPDATE_ENTITY_INFO: '/manage/update-entity-information/instruction',
  FINANCIAL_YEAR_END: '/manage/change-financial-year-end-date/instruction',
  NOTICE_OF_ERROR: '/manage/notice-of-error/instruction',
  MAINTENANCE_OF_CSP_CLIENT_LIST:
    '/manage/maintenance-of-csp-client-list/instruction',
  UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS:
    '/manage/update-of-entity-position-holder-nominators/instruction',
} as const;

export const INSTRUCTION_PAGE_HEADERS = {
  [PRE_LOGIN_INSTRUCTION_ROUTES.NAME_APPLICATION]:
    'Apply for new business entity name',
  [PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_REGISTRATION]:
    'Register new business entity',
  [PRE_LOGIN_INSTRUCTION_ROUTES.CESSATION_DISSOLUTION]:
    'File cessation or dissolution of business entity',
  [PRE_LOGIN_INSTRUCTION_ROUTES.STRIKE_OFF]:
    'Apply to strike off business entity',
  [PRE_LOGIN_INSTRUCTION_ROUTES.POST_STRIKE_OFF]: 'Manage striking off',
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_EDIT_PERSONNEL]:
    'Update position holder information',
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_PERSONNEL_APPOINTMENT_WITHDRAWAL]:
    'Appoint/Withdraw position holder',
  [PRE_LOGIN_INSTRUCTION_ROUTES.REDUCTION_SHARE_CAPITAL]:
    'Update reduction of share capital',
  [PRE_LOGIN_INSTRUCTION_ROUTES.REGISTRATION_OF_CHARGES]: 'Register new charge',
  [PRE_LOGIN_INSTRUCTION_ROUTES.COMMON_SHARES]: 'Update shares information',
  [PRE_LOGIN_INSTRUCTION_ROUTES.ANNUAL_RETURNS_DECLARATIONS]:
    'File annual returns',
  [PRE_LOGIN_INSTRUCTION_ROUTES.GENERAL_LODGEMENT]: 'General lodgement',
  [PRE_LOGIN_INSTRUCTION_ROUTES.ENTITY_RENEWAL]: 'Renew business registration',
  [PRE_LOGIN_INSTRUCTION_ROUTES.OBJ_STRIKING_OFF]:
    'Submit/Clear objections against striking off',
  [PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_QUALIFIED_INDIVIDUAL]:
    'Register as a registered qualified individual',
  [PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_QUALIFIED_INDIVIDUAL]:
    'Renew registration as registered qualified individual',
  [PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_RORC]:
    'Update Register of Registrable Controller',
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_SHAREHOLDER]:
    'Update shareholder information',
  [PRE_LOGIN_INSTRUCTION_ROUTES.INITIATION_OF_WINDING_UP]:
    'File winding up of business entity',
  [PRE_LOGIN_INSTRUCTION_ROUTES.EXTENSION_OF_TIME]:
    'Apply for extension of time',
  [PRE_LOGIN_INSTRUCTION_ROUTES.VARIATION_SATISFACTION]:
    'File variation/satisfaction of charges',
  [PRE_LOGIN_INSTRUCTION_ROUTES.REGISTER_CORPORATE_SERVICE_PROVIDER]:
    'Register as corporate service provider',
  [PRE_LOGIN_INSTRUCTION_ROUTES.RENEW_CSP]:
    'Renew registration as corporate service provider',
  [PRE_LOGIN_INSTRUCTION_ROUTES.POST_INITIATION_OF_WINDING_UP]:
    'Manage winding up',
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_ENTITY_INFO]:
    'Update entity information',
  [PRE_LOGIN_INSTRUCTION_ROUTES.FINANCIAL_YEAR_END]:
    'Update change of financial year end date',
  [PRE_LOGIN_INSTRUCTION_ROUTES.NOTICE_OF_ERROR]: 'File Notice of Error',
  [PRE_LOGIN_INSTRUCTION_ROUTES.MAINTENANCE_OF_CSP_CLIENT_LIST]:
    'Maintain corporate service provider client list',
  [PRE_LOGIN_INSTRUCTION_ROUTES.UPDATE_DIRECTORS_AND_SHAREHOLDER_NOMINATORS]:
    'Update Registers of Nominee Directors and Nominee Shareholders',
} as const;
